/** @format */
import React, { FunctionComponent } from 'react';

import {
    StyledLabelSkeleton,
    StyledOptionSkeleton,
    StyledSelectSkeleton,
} from './select.styles';

export const SelectSkeleton: FunctionComponent = () => (
    <StyledSelectSkeleton>
        <StyledLabelSkeleton />
        <StyledOptionSkeleton />
    </StyledSelectSkeleton>
);
